import "./AttendanceTable.css";
import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { format } from "date-fns";
import { reverseGeocode } from '../../Utils/geocode'
import { BigTexts, LightDark, LighterBold, smallText } from "../../Assets/CSS/Text";
import { Button, Modal } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";


const AttendanceTable = ({ refreshKey, attendanceList, setAttendanceList }) => {
  const [weeklyData, setWeeklyData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedTask, setEditedTask] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");

  // const handleClose = () => setShowModal(false);
  // const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setSelectedDescription("");
  };
  const handleShow = (description) => {
    setSelectedDescription(description);
    setShowModal(true);
  };
  // const getTruncatedText = (text) => {
  //   return text.split(" ").length > 4
  //     ? (
  //       <>
  //         {text.split(" ").slice(0, 3).join(" ")}...

  //         <Button
  //           variant="link"
  //           size="sm"
  //           onClick={() => handleShow(text)}
  //         >
  //           {/* Read More */}
  //           <span
  //             // onClick={onClickHandler}
  //             style={{ color: '#00AFEF', cursor: 'pointer' }}
  //           >
  //             ...more
  //           </span>
  //         </Button>
  //       </>
  //     )
  //     : text;
  // };
  const getTruncatedText = (text) => {
    if (!text) return "";

    const wordCount = text.trim().split(" ").length;
    const charCount = text.length;

    // Check if more than 3 words OR 9 characters
    if (wordCount > 3 || charCount > 9) {
      const truncated = text.slice(0, 9); // show first 8 characters

      return (
        <>
          {truncated}...
          <Button
            variant="link"
            size="sm"
            onClick={() => handleShow(text)}
          >
            <span style={{ color: "#00AFEF", cursor: "pointer" }}>
              more
            </span>
          </Button>
        </>
      );
    }

    // Otherwise return the text as it is
    return text;
  };

  console.log(weeklyData, "week")
  const getUserRole = () => {
    const roles = localStorage.getItem("roles");
    return roles ? roles.split(",") : [];
  };
  const roles = getUserRole();

  useEffect(() => {
    const today = new Date();
    const { startOfWeek, endOfWeek } = getWeekRange(today);
    setStartDate(startOfWeek);
    setEndDate(endOfWeek);
    fetchWeeklyData(startOfWeek, endOfWeek);
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      fetchWeeklyData(startDate, endDate);
    }
  }, [refreshKey]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getWeekRange = (date) => {
    const currentDate = new Date(date);
    const dayOfWeek = currentDate.getDay();
    const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() + diffToMonday);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    return {
      startOfWeek: formatDate(startOfWeek),
      endOfWeek: formatDate(endOfWeek),
    };
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  function formatTime(timeStr) {
    if (!timeStr || typeof timeStr !== "string") return "N/A";

    try {
      // Handle different time formats
      let timePart;

      // Check if it's a full datetime string (e.g., "24-09-2025 15:07::16")
      if (timeStr.includes(" ") && (timeStr.includes("::") || timeStr.includes(":"))) {
        // Split by space to get date and time parts
        const [datePart, timePartStr] = timeStr.split(" ");

        // Handle double colon format (::) and single colon format (:)
        timePart = timePartStr.replace("::", ":");

        // Validate the date part (DD-MM-YYYY format)
        const [day, month, year] = datePart.split("-");
        const dayNum = parseInt(day);
        const monthNum = parseInt(month);
        const yearNum = parseInt(year);

        // Check for invalid date (e.g., 24th month, 32nd day, etc.)
        if (monthNum > 12 || monthNum < 1 || dayNum > 31 || dayNum < 1 || yearNum < 1900) {
          console.warn(`Invalid date format: ${datePart}`);
          return "Invalid Date";
        }
      } else {
        // Handle time-only format (e.g., "15:07:16")
        timePart = timeStr.replace("::", ":");
      }

      // Parse the time part
      const [hours, minutes, seconds] = timePart.split(":");

      // Validate time components
      const hoursNum = parseInt(hours);
      const minutesNum = parseInt(minutes);
      const secondsNum = parseInt(seconds || "0");

      if (hoursNum > 23 || hoursNum < 0 || minutesNum > 59 || minutesNum < 0 || secondsNum > 59 || secondsNum < 0) {
        console.warn(`Invalid time format: ${timePart}`);
        return "Invalid Time";
      }

      // Create a valid date string for today with the parsed time
      const today = new Date();
      const dateStr = today.toISOString().split("T")[0]; // Use current date
      const fullTimeStr = `${dateStr}T${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:${(seconds || "00").padStart(2, "0")}`;

      // Parse with server's timezone (assuming server time is IST)
      const serverTime = new Date(fullTimeStr);

      // Check if the date is valid
      if (isNaN(serverTime.getTime())) {
        console.warn(`Invalid date/time: ${fullTimeStr}`);
        return "Invalid Date";
      }

      const options = {
        timeZone: "Asia/Kolkata", // Explicitly set to Kolkata (IST)
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      };

      // Convert to Kolkata timezone
      const kolkataTime = serverTime.toLocaleString("en-US", options);
      return kolkataTime;

    } catch (error) {
      console.error(`Error formatting time: ${timeStr}`, error);
      return "Invalid Format";
    }
  }
  const parseLatLongString = (str) => {
    if (!str) return null;
    const latMatch = str.match(/Lat:\s*(-?\d+(\.\d+)?)/i);
    const lonMatch = str.match(/Long:\s*(-?\d+(\.\d+)?)/i);
    if (latMatch && lonMatch) {
      return {
        lat: parseFloat(latMatch[1]),
        lon: parseFloat(lonMatch[1]),
      };
    }
    return null;
  };

  const fetchWeeklyData = async (startOfWeek, endOfWeek) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets/my/date-range?startDate=${startOfWeek}&endDate=${endOfWeek}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();

      console.log("data:", data);

      const dataWithReadableLocations = await Promise.all(
        data?.content.map(async (entry) => {
          const loginCoords = parseLatLongString(entry.checkInLocation);
          const logoutCoords = parseLatLongString(entry.checkOutLocation);
          console.log("loginCoords", loginCoords);
          console.log("logoutCoords", logoutCoords);

          const loginLocationName = loginCoords
            ? await reverseGeocode(loginCoords.lat, loginCoords.lon)
            : "N/A";
          console.log("loginLocationName", loginLocationName);

          const logoutLocationName = logoutCoords
            ? await reverseGeocode(logoutCoords.lat, logoutCoords.lon)
            : "N/A";
          console.log("logoutLocationName", logoutLocationName);
          return {
            ...entry,
            loginLocationName,
            logoutLocationName,
          };
        })
      );
      console.log("dataWithReadableLocations", dataWithReadableLocations);


      const groupData = groupDataByDate(dataWithReadableLocations);
      console.log("groupData", groupData);

      const dataForWeek = groupData.filter(
        (item) => item.timesheetDate >= startOfWeek && item.timesheetDate <= endOfWeek
      );
      setWeeklyData(dataForWeek);
    } catch (error) {
      console.error("Error fetching weekly attendance data:", error);
      setWeeklyData([]);
    }
    finally {
      setLoading(false);
    }
  };

  const groupDataByDate = (dataArray) => {
    const groupedData = dataArray.reduce((acc, item) => {
      if (!acc[item.timesheetDate]) {
        acc[item.timesheetDate] = [];
      }
      acc[item.timesheetDate].push(item);
      return acc;
    }, {});
    return Object.keys(groupedData).map((timesheetDate) => ({
      timesheetDate,
      employees: groupedData[timesheetDate],
    }));
  };

  const handlePrevWeek = () => {
    const prevWeekStart = new Date(startDate);
    prevWeekStart.setDate(prevWeekStart.getDate() - 7);
    const { startOfWeek, endOfWeek } = getWeekRange(prevWeekStart);
    setStartDate(startOfWeek);
    setEndDate(endOfWeek);
    setLoading(true); // 👈 force skeleton immediately
    fetchWeeklyData(startOfWeek, endOfWeek);
  };

  const handleNextWeek = () => {
    const nextWeekStart = new Date(startDate);
    nextWeekStart.setDate(nextWeekStart.getDate() + 7);
    const { startOfWeek, endOfWeek } = getWeekRange(nextWeekStart);
    setStartDate(startOfWeek);
    setEndDate(endOfWeek);
    setLoading(true); // 👈 force skeleton immediately
    fetchWeeklyData(startOfWeek, endOfWeek);
  };
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const options = { month: "short", day: "2-digit" };
    const formatted = date.toLocaleDateString("en-US", options);
    const yearShort = String(date.getFullYear()).slice(-2);
    return `${formatted} ‘${yearShort}`;
  };
  const saveTask = async (details) => {
    console.log("details timesheet id", details);

    // API URL matches the curl specification: /api/v1/timesheets/{timeSheetId}/my/time-sheets/update-task
    const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets/${details.timeSheetId}`;

    // Request body matches the curl specification: {"taskDescription": "string"}
    const requestBody = {
      taskDescription: details.task,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "PATCH", // Matches curl -X 'PATCH'
        headers: {
          accept: "*/*", // Matches curl -H 'accept: */*'
          "Content-Type": "application/json", // Matches curl -H 'Content-Type: application/json'
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody), // Matches curl -d '{"taskDescription": "string"}'
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Task updated successfully:", result);
        fetchWeeklyData(startDate, endDate);
      } else {
        console.error("Failed to update task:", response.statusText);
        const errorData = await response.text();
        console.error("Error details:", errorData);
      }
    } catch (error) {
      console.error("Error while updating task:", error);
    }
  };
  /*
    const handleEditTask = (index, currentTask) => {
      setEditingIndex(index);
      setEditedTask(currentTask || "");
    };
    */
  const handleEditTask = (index, currentTask) => {
    setEditingIndex(index);

    if (currentTask && currentTask.trim()) {
      const task = currentTask.trim();

      // Add bullet to first line if it doesn't already have one
      setEditedTask(
        task.startsWith("• ")
          ? task
          : `• ${task}`
      );
    } else {
      setEditedTask("• ");
    }
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditedTask("");
  };

  const handleSaveTask = async () => {
    const entry = filteredAttendance[editingIndex];
    if (!entry) return;
    console.log("entry", entry);

    const updatedDetails = {

      timeSheetId: entry.timesheetId,
      date: entry.timesheetDate,
      task: editedTask,
    };

    await saveTask(updatedDetails);


    setWeeklyData((prevWeeklyData) => {
      return prevWeeklyData.map((day) => {
        if (day.date !== updatedDetails.date) return day;

        const updatedEmployees = day.employees.map((emp) =>
          emp.timeSheetId === updatedDetails.timeSheetId
            ? { ...emp, taskDiscription: editedTask }
            : emp
        );

        return { ...day, employees: updatedEmployees };
      });
    });

    setEditingIndex(null);
    setEditedTask("");
  };

  console.log("weeklyData", weeklyData);

  const filteredAttendance = weeklyData.flatMap((entry) =>

    entry.employees.map((e) => ({
      ...e,
      date: entry.date,
      taskDescription: e.taskDescription || "",
    }))
  );

  console.log("filteredAttendance", filteredAttendance);


  return (
    <div className="attendance-table">
      <div className="attendance-header">

        <h6 style={BigTexts}>Weekly Attendance </h6>

        <div className="week-controls">
          <Icon icon="uil:calender" width="24" height="24" />
          <span className="week-range" style={LightDark}>
            {/* {startDate} - {endDate} */}
            {formatDisplayDate(startDate)} - {formatDisplayDate(endDate)}
          </span>
          <button onClick={handlePrevWeek}>
            <Icon icon="iconamoon:arrow-left-2" width="18" height="18" />
          </button>
          <button onClick={handleNextWeek}>
            <Icon icon="iconamoon:arrow-right-2" width="18" height="18" />
          </button>
        </div>
      </div>

      {!isMobile ? (
        <table>
          <thead>
            <tr className="border rounded">
              <th style={LighterBold}>Date</th>
              <th style={LighterBold}>Login Time</th>
              <th style={LighterBold}>Login Location</th>
              <th style={LighterBold}>Logout Time</th>
              <th style={LighterBold}>Logout Location</th>
              <th style={LighterBold}>Total Hours</th>
              <th style={{ ...LighterBold, textAlign: 'center' }}>Tasks</th>
              <th style={LighterBold}>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              [...Array(5)].map((_, i) => (
                <tr key={i}>
                  <td><Skeleton width={100} /></td>
                  <td><Skeleton width={80} /></td>
                  <td><Skeleton width={150} /></td>
                  <td><Skeleton width={80} /></td>
                  <td><Skeleton width={150} /></td>
                  <td><Skeleton width={70} /></td>
                  <td><Skeleton width={70} /></td>
                  <td><Skeleton width={40} /></td>
                </tr>
              ))
            ) :
              filteredAttendance.length === 0 ? (
                <tr>
                  <td colSpan="7" className="no-records">
                    No records available
                  </td>
                </tr>
              ) : (
                filteredAttendance.map((entry, index) => (

                  <tr key={index}>
                    {console.log("table:::", entry)
                    }
                    <td style={LightDark}>{format(new Date(entry.timesheetDate), "dd MMM yyyy")}</td>
                    <td style={LightDark}>{formatTime(entry.checkInTime)}</td>
                    <td style={LightDark}>{entry.loginLocationName || "Loading..."}</td>
                    <td style={LightDark}>{formatTime(entry.checkOutTime)}</td>
                    <td style={LightDark}>{entry.logoutLocationName || "Loading..."}</td>
                    <td style={LightDark}>{entry.workedHoursFormatted}</td>

                    <td>
                      {getTruncatedText(entry.taskDescription)}
                    </td>
                    <td>
                      <button
                        className="edit-btns"
                        onClick={() => handleEditTask(index, entry.taskDescription)}
                      >
                        <Icon icon="mdi:edit" width="18" height="18" className="edit-icon" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
          </tbody>
        </table>
      ) : (
        <div className="attendance-cards">
          {loading ? (
            [...Array(3)].map((_, i) => (
              <div className="attendance-card" key={i}>
                <div className="card-header">
                  <Skeleton height={20} width={120} />
                </div>
                <div className="card-body">
                  <Skeleton height={15} width={200} style={{ marginTop: 8 }} />
                  <Skeleton height={15} width={200} style={{ marginTop: 8 }} />
                  <Skeleton height={15} width={200} style={{ marginTop: 8 }} />
                  <Skeleton height={15} width={200} style={{ marginTop: 8 }} />
                </div>
              </div>
            ))
          ) : filteredAttendance.length === 0 ? (
            <div className="no-records">No records available</div>
          ) : (
            filteredAttendance.map((entry, index) => (
              <div className="attendance-card" key={index}>
                <div className="card-header">
                  <h4>{format(new Date(entry.timesheetDate), "dd-MM-yyyy")}</h4>
                </div>
                <div className="card-body">


                  {/* Headings row */}
                  <div className="row">
                    <div className="col">
                      <h6 style={{ ...smallText, paddingTop: '5px' }}>Login</h6>
                    </div>
                    <div className="col">
                      <h6 style={{ ...smallText, paddingTop: '5px' }}>Logout</h6>
                    </div>
                  </div>

                  {/* Times row */}
                  <div className="row">
                    <div className="col">
                      <h6 style={LightDark}>
                        {entry.checkInTime ? formatTime(entry.checkInTime) : 'N/A'}
                      </h6>
                    </div>
                    <div className="col">
                      <h6 style={LightDark}>
                        {entry.checkOutTime ? formatTime(entry.checkOutTime) : 'N/A'}
                      </h6>
                    </div>
                  </div>

                  {/* Locations row */}
                  <div className="row">
                    <div className="col">
                      <h6 style={LightDark}>
                        {entry.loginLocationName || 'Unknown Location'}
                      </h6>
                    </div>
                    <div className="col">
                      <h6 style={LightDark}>
                        {entry.logoutLocationName || 'Unknown Location'}
                      </h6>
                    </div>
                  </div>


                  <div className="card-edit-icon mt-1">
                    <p>
                      <strong style={LighterBold}>Task:</strong>
                      <span>{entry.taskDescription}</span>
                    </p>
                    <button
                      className="edit-btns"
                      onClick={() => handleEditTask(index, entry.taskDescription)}
                    >
                      <Icon icon="mdi:edit" width="20" height="20" className="text-[#EBFAFF] hover:text-[#00AFEF] cursor-pointer" />
                    </button>
                  </div>
                </div>

              </div>
            ))
          )}
        </div>
      )}

      {editingIndex !== null && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>Edit Task</h4>
            {/*
            <textarea
              className="task-textarea"
              value={editedTask}
              onChange={(e) => setEditedTask(e.target.value)}
              rows="10"
            />
            */}
            <textarea
              className="task-textarea"
              value={editedTask}
              onChange={(e) => setEditedTask(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();

                  setEditedTask((prev) => prev + "\n• ");
                }
              }}
              rows="10"
            />
            <div className="modal-actions">
              <button className="cancel-btn" onClick={handleCancelEdit}>
                Cancel
              </button>
              <button className="save-btn" onClick={handleSaveTask}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ✅ Single modal outside the loop */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Task Description</Modal.Title>
        </Modal.Header>
        {/*}
        <Modal.Body>{selectedDescription}</Modal.Body>
        */}
        <Modal.Body>
          {selectedDescription ? (
            <ul style={{ paddingLeft: "20px", marginBottom: 0 }}>
              {selectedDescription
                .split("\n")
                .map((task, index) => {
                  const cleanTask = task.replace(/^•\s*/, "").trim();

                  if (!cleanTask) return null;

                  return (
                    <li key={index} style={{ marginBottom: "5px" }}>
                      {cleanTask}
                    </li>
                  );
                })}
            </ul>
          ) : (
            "N/A"
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AttendanceTable;
